<div class="sopo-popup-inner-container">
    <span class="sopo-popup-title">QUICKPLAY</span>
    <span class="sopo-popup-text">
        You are about to open a quickplay table where you can share a link with friends to play poker instantly!
        There are preset rules, but you may adjust the settings once at the table.
    </span>
    <span class="sopo-popup-text">
        If you would like access to the full suite of features within SOPO, create a club, and track your progress,
        you must create an account or log into an existing account. Once logged in, you may still generate a
        quickplay table, as well as explore other game modes.
    </span>
    <span class="sopo-popup-text note">
        Please note that this version of SOPO is exclusive to desktop users, and due to app store restrictions,
        it will not be available on mobile.
    </span>
    <span class="sopo-popup-text prompt">
        Are you sure you want to create a quickplay table as a guest?
    </span>
    <div class="sopo-popup-button-container">
        <div class="sopo-popup-red-button clickable" (click)="close(false)">CANCEL</div>
        <div class="sopo-popup-green-button clickable" (click)="close(true)">CREATE</div>
    </div>
</div>
